import { SvgIcon, SvgIconProps } from "@mui/material";

export const H2Icon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
        d="M17 14a1 1 0 0 1 1-1h.614c.53 0 .999.338 1.166.84v0c.136.41.048.86-.233 1.188L17 18h3M5 6v12M13 6v12M5 12h8"
      />
    </svg>
  </SvgIcon>
);
